import iotDeviceFeatureConfigService from '../../../../services/iotDevice/iotDeviceFeatureConfigService';
import iotDeviceGlobalConfigService from '../../../../services/iotDevice/iotDeviceGlobalConfigService';
import iotDeviceSettingsService from '../../../../services/iotDevice/iotDeviceSettingsService';

const useVibrationModeEnabled = (iotDevice) => {
    const isGlobalVibration = iotDeviceGlobalConfigService.isGlobalVibration(iotDevice);
    const isVibrationEnabled = iotDeviceSettingsService.isSettingAvailable(
        iotDevice,
        isGlobalVibration,
        iotDeviceFeatureConfigService.isVibrationEnabled()
    );

    return isVibrationEnabled;
};

export default useVibrationModeEnabled;
